import React from 'react'
import { find, propEq } from 'ramda'
import QuestionText from '../QuestionText'

export const ChooseOneSummary = ({ params: { id, heading, options }, answers }) => {
  const { text = '' } = find(propEq('id', answers[id]), options) || {}

  return text && <QuestionText params={{ heading, text }} />
}
